module.exports = __webpack_public_path__ + "img/house_battery_idle_online.fafb8062.png";